// extracted by mini-css-extract-plugin
export default {"root":"UserEditPage_root__FiOIj","label":"UserEditPage_label__4AYqk","errorMessage":"UserEditPage_errorMessage__ugfRw"};